import React from "react";
import { useState } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell,
    ReferenceArea,
} from "recharts";

import CustomLabel from "./CustomLabel";
import CustomLegend from "./CustomLegend";
import CustomTooltip from "./CustomToolTip";

const WaterfallChart = ({ reportData, setAdjType }) => {
    const [selectedBarIndex, setSelectedBarIndex] = useState(null);

    const handleClick = (index) => {
        if (selectedBarIndex == index) {
            setSelectedBarIndex(null);
            setAdjType("");
        } else {
            setSelectedBarIndex(index);
            setAdjType(
                reportData.data[index].adjType === "0" ? "" : reportData.data[index].adjType
            );
        }
    };

    return (
        <div className="w-full cursor-pointer">
            {/* {JSON.stringify(reportData.productGroups)} */}
            <ResponsiveContainer width="100%" height={500}>
                <BarChart
                    data={reportData.data}
                    margin={{ top: 20, right: 30, left: 20, bottom: 100 }}
                    onClick={(e) => {
                        if (e && e.activeTooltipIndex !== undefined) {
                            handleClick(e.activeTooltipIndex);
                        }
                    }}
                    className="cursor-pointer"
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" angle={-45} textAnchor="end" />
                    <YAxis
                        type="number"
                        domain={[reportData.domain.min, reportData.domain.max]}
                        allowDataOverflow={true}
                        tickFormatter={(value) => value.toLocaleString()}
                        label={{
                            value: "In $000s",
                            angle: -90,
                            position: "insideLeft",
                            offset: -10,
                            style: { textAnchor: "middle", fontSize: 13 },
                        }}
                    />
                    <Tooltip content={<CustomTooltip />} />

                    {/* Highlight background of selected bar */}
                    {selectedBarIndex !== null && (
                        <ReferenceArea
                            x1={reportData.data[selectedBarIndex].name}
                            x2={reportData.data[selectedBarIndex].name}
                            stroke="none"
                            fill="gray" // light yellow background
                            fillOpacity={0.5}
                        />
                    )}

                    <Bar dataKey="pv" stackId="a" fill="transparent" />
                    <Bar
                        dataKey="CARR"
                        stackId="a"
                        fill="#e97132"
                        name="Increase"
                        label={<CustomLabel data={reportData.data} />}
                        onClick={(_, index) => handleClick(index)}
                    >
                        {reportData.data.map((item, index) => {
                            if (item.CARR < 0)
                                return <Cell cursor="pointer" key={index} fill="#00b0f0" />;
                            if (item.name === "Existing" || item.name === "Final")
                                return <Cell key={index} fill="#156082" />;
                            return <Cell key={index} fill="#e97132" />;
                        })}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
            <CustomLegend data={reportData.data} />
        </div>
    );
};

export default WaterfallChart;
